import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {ErrorToaster, SuccessToaster} from "../../../shared/toaster";
import {useTranslation} from "react-i18next";
import axios from "axios";
import {IoArrowBackOutline, IoClose} from "react-icons/io5";
import {useLocation, useNavigate, useParams} from "react-router";
import {toFarsiNumber} from "../../../shared/toFarsiNumber";
import {ConvertGregorianToJalali} from "../../../shared/convertGregorianToJalali";
import {Field} from "../../../components/fouladyar/field/field";
import {Button, Row} from "reactstrap";
import {MdOutlineEditNote, MdPlaylistAddCheck} from "react-icons/md";
import {LiaMoneyBillWaveSolid} from "react-icons/lia";
import {Col} from "../../../components/grid/Grid";
import {copyToClipboard} from "../../../shared/copyToClipboard";



export function InvoiceValueItem({title, value}){
    return(
        <div className="invoice-value-item" onClick={() => {
            copyToClipboard(value)
        }}>
            <div className="key">{title}</div>
            {/*<div className="dotted"/>*/}
            <div className="value">{value}</div>
        </div>
    )
}

const WithdrawConfirmation = () => {

    const {t, i18n} = useTranslation();
    const {id} = useParams();
    const location = useLocation();
    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const [data, setData] = useState({
        status: 'success'
    });
    const [isLoading, setIsLoading] = useState(true);
    const [isApplyingFilter, setIsApplyingFilter] = useState(false);
    const [pagination, setPagination] = useState({
        itemPerPage: 7,
        currentPage: 1,
        totalItems: 0,
        lastUpdateBy: ''
    })
    const navigate = useNavigate();
    const [withdraw, setWithdraw] = useState({
        transactionUrl: '',
        description: ''

    });
    const [profile, setProfile] = useState({
        _id: "",
        fullName: "",
        kycDetails: null,

    })

    async function loadData() {
        console.log('withdrawid', id)
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/withdraw/${id}`, {
            headers: {authorization: `Bearer ${auth.token}`}
        })
        console.log('loaddata', res.data)
        if (res.data.statusCode === 200) {

            setWithdraw((prevState) => ({
                ...prevState,
                ...res.data.data
            }));
            // setIsloading(false);
            return data;
        }

        return {};

    }

    async function loadAccountBalance(accountId) {

       try {
           const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/analysis/account-info/${accountId}`, {
               headers: {authorization: `Bearer ${auth.token}`}
           })
           const res2 = await axios.get(`${process.env.REACT_APP_API_URL}/api/analysis/account-initial-capital/${accountId}`, {
               headers: {authorization: `Bearer ${auth.token}`}
           })
           console.log('loaddata', res.data)
           if (res.data.statusCode === 200) {

               setWithdraw((prevState) => ({
                   ...prevState,
                   initialCapital: res2.data.data.initialCapital,
                   balance: res.data.data.balance,
                   equity: res.data.data.equity
               }));
               // setIsloading(false);
               return data;
           }

           return {};
       }catch (e) {

           ErrorToaster(e, t)
       }

    }


    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        if(withdraw?.account?.metaapi_id){
            loadAccountBalance(withdraw?.account?.metaapi_id)
        }
    }, [withdraw?.account?.metaapi_id]);

    function calculateProfit(){
        const profit = withdraw?.equity - withdraw?.initialCapital;

        if(profit < 0)
            return 0

        return profit * 0.8;
    }

    async function completeWithdraw() {
        try {
            const res = await axios.put(`${process.env.REACT_APP_API_URL}/api/withdraw/complete/${id}`, {
                amount: calculateProfit(),
                extras: withdraw
            },{
                headers: {authorization: `Bearer ${auth.token}`}
            })
            console.log('loaddata', res.data)
            if (res.data.statusCode === 200) {
                SuccessToaster({message: 'ثبت برداشت با موفقیت ثبت شد'})
                navigate('/app/support/withdraw-list')
            }

            return {};
        }catch (e) {

            ErrorToaster(e, t)
        }
    }

    return (
        <React.Fragment>


            <div className="grid-header">
                <div className="title-with-tab">
                    <h3>تسویه حساب</h3>
                </div>
                <button className="btn small-button grid-action-btn" type="button" onClick={() => {
                    navigate('/app/support/withdraw-list')
                }}>
                    <IoArrowBackOutline size={17} color={"#49e7ad"}/>
                </button>
            </div>


            <div className="mt-4 mb-5">

                <h3 className={'yellow-color morabba-font'}>تسویه حساب ریل </h3>
                <p className={'gray-color'} style={{
                    fontSize: "18px",
                    margin: "20px 0px"
                }}>
                    دقت کنید که قبل از تسویه حساب، همه جوانب حساب کاربر رو به دقت بررسی کنید. مطمئن شوید که وضعیت بخش های مختلف چالش صحیح و مورد قبول باشد و هیچ مشکل یا تناقضی نداشته باشه. اطمینان حاصل کنید که همه اطلاعات مربوط به حساب‌ کاربر، مانند وضعیت غیرفعال بودن یا مسدود شدن حساب، به درستی بررسی شده باشه.
                    <br/>
                    <br/>
                    اگر حساب مشکوک به فعالیت غیرعادی یا تعلیق است، باید به صورت جداگانه بررسی بشه. همچنین بررسی کن که آیا کاربر درخواست‌های  قبلی دارد یا خیر. پس از تأیید همه موارد، میتوانید با اطمینان تسویه حساب را انجام دهید.
                    <br/>
                </p>
                <Button  className="btn yellow-bg-color custom-button" size="md"  onClick={async () => {
                    navigate(`/analytics/${withdraw?.account?.metaapi_id}`)
                }}>
                    بررسی حساب
                </Button>
                <div className="withdraw-status-container">
                    <LiaMoneyBillWaveSolid size={80} color={"#38AF84"}/>
                    <div className="payment-status-header">
                        <h1 className="success">تصویه حساب</h1>
                    </div>

                    <InvoiceValueItem title={"شماره حساب"} value={withdraw?.account?.username || '-'}/>
                    <InvoiceValueItem title={"شناسه متا"} value={withdraw?.account?.metaapi_id || '-'}/>
                    <InvoiceValueItem title={"آدرس ولت"} value={`${withdraw?.wallet?.cardNumber || '-'}`}/>
                    <InvoiceValueItem title={"شبکه ولت"} value={`${withdraw?.wallet?.walletNetwork || '-'}`}/>
                    <InvoiceValueItem title={"وضعیت تسویه حساب"} value={withdraw.status}/>

                    <div className="payment-divider"></div>
                    <InvoiceValueItem title={"بالانس اولیه"} value={`$${toFarsiNumber(withdraw?.initialCapital || '-')}`}/>
                    <InvoiceValueItem title={"بالانس فعلی"} value={`$${toFarsiNumber(withdraw?.balance || '-')}`}/>
                    <InvoiceValueItem title={"ایکوئیتی"} value={`$${toFarsiNumber(withdraw?.equity || '-')}`}/>
                    <InvoiceValueItem title={"مبلغ واریزی"} value={`$${toFarsiNumber(calculateProfit()  || 0)}`}/>

                </div>



                <div className="withdraw-form-container">

                    <Row key={`row-1`} className={`field-item-container`}>
                        <Col  className={`field-item `} key={`1`}>
                            <div className="field-item-title-and-desc">
                                <div className="field-item-title">
                                    {"آدرس تراکنش"}
                                </div>
                                <div className="field-item-description">
                                    {"پس از واریز مبلغ به کیف پول کاربر مورد نظر، لینک تراکنش موفق را در این بخش وارد کنید"}
                                </div>
                            </div>
                            <div className="field-item-input">
                                <Field
                                    id={'transaction-url'}
                                    name={"transaction-url"}
                                    value={withdraw.transactionUrl}
                                    type={"text"}
                                    onChange={(e) => {
                                        setWithdraw(prevState => {
                                            return{
                                                ...prevState,
                                                transactionUrl: e
                                            }
                                        })
                                    }}
                                />
                            </div>

                        </Col>
                    </Row>


                    <Row key={`row-2`} className={`field-item-container`}>
                        <Col  className={`field-item `} key={`2`}>
                        <div className="field-item-title-and-desc">
                            <div className="field-item-title">
                                {"توضیحات"}
                            </div>
                            <div className="field-item-description">
                                {"در صورتی که در فرآیند پرداخت و تسویه حساب به نکته ای برخورد کرده اید لطفا آن را در فیلد توضیحات برای کاربر وارد کنید."}
                            </div>
                        </div>
                        <div className="field-item-input">
                            <Field
                                id={'description'}
                                name={"description"}
                                value={withdraw.description}
                                type={"textarea"}
                                onChange={(e) => {
                                    setWithdraw(prevState => {
                                        return{
                                            ...prevState,
                                            description: e
                                        }
                                    })
                                }}
                            />
                        </div>

                    </Col>
                    </Row>




                </div>
                <Button style={{width:"100%"}} disabled={profile?.kycDetails?.status === 'approved'} className="green-button" size="md"
                        type="submit" onClick={async () => {
                            await completeWithdraw()
                }}>
                    ثبت
                </Button>
            </div>

        </React.Fragment>
    );
};

export default WithdrawConfirmation;
